import React, { useState, useMemo, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { lightTheme, darkTheme } from "./utils/theme";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Attendance from "./components/Attendance";
import Profile from "./components/Profile";
import Leave from "./components/Leave";
import Task from "./components/Task";
import Navbar from "./components/Navbar";

function App() {
  // Check if user is authenticated (token & expiry stored in localStorage)
  const checkAuth = () => {
    const token = localStorage.getItem("authToken");
    const expiry = localStorage.getItem("authExpiry");
    const email = localStorage.getItem("userEmail");
    if (token && expiry && Date.now() < parseInt(expiry)) {
      return { isAuthenticated: true, email };
    }
    return { isAuthenticated: false, email: "" };
  };

  const initialAuth = checkAuth();
  const [authenticated, setAuthenticated] = useState(initialAuth.isAuthenticated);
  const [userEmail, setUserEmail] = useState(initialAuth.email || "");
  const [darkMode, setDarkMode] = useState(false);
  
  const theme = useMemo(() => (darkMode ? darkTheme : lightTheme), [darkMode]);

  // Prevent browser back navigation when authenticated
  useEffect(() => {
    if (authenticated) {
      window.history.pushState(null, "", window.location.href);
      const handlePopstate = () => window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", handlePopstate);
      return () => window.removeEventListener("popstate", handlePopstate);
    }
  }, [authenticated]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {authenticated && <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />}
        <Routes>
          <Route
            path="/"
            element={
              authenticated ? (
                <Dashboard setAuthenticated={setAuthenticated} darkMode={darkMode} setDarkMode={setDarkMode} />
              ) : (
                <Login setAuthenticated={setAuthenticated} setUserEmail={setUserEmail} />
              )
            }
          />
          <Route
            path="/dashboard"
            element={authenticated ? <Dashboard setAuthenticated={setAuthenticated} darkMode={darkMode} setDarkMode={setDarkMode} /> : <Navigate to="/" />}
          />
          <Route
            path="/attendance"
            element={authenticated ? <Attendance email={userEmail} /> : <Navigate to="/" />}
          />
          <Route
            path="/profile"
            element={authenticated ? <Profile email={userEmail} /> : <Navigate to="/" />}
          />
          <Route
            path="/leave"
            element={authenticated ? <Leave email={userEmail} /> : <Navigate to="/" />}
          />
          <Route
            path="/task"
            element={authenticated ? <Task email={userEmail} /> : <Navigate to="/" />}
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
